export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = 4